<template>
	<header class="app-header">
		<div class="app-header__login-info" v-if="idRegister">
			<p class="app-header__login-info__nickname">
				<b>{{ nickname }}</b
				>님 환영합니다!
			</p>
		</div>
		<div class="app-header__menu">
			<div class="app-header__menu__side-left">
				<a class="app-header__menu__logo" :href="`/`">
					<img :src="`${imgUrl}/logo-glowpick-admin2.png`" />
				</a>
				<NavBox
					v-if="isWidthOverlimit || menuIsOpen"
					@logout="logout"
					@toggleNav1="toggleNav1"
					:isWidthOverlimit="isWidthOverlimit"
					:menuIsOpen="menuIsOpen"
					:nav1Open="nav1Open"
				/>
			</div>
			<div class="app-header__menu__side-right">
				<button
					class="btn app-header__menu__btn-logout"
					type="button"
					v-if="isWidthOverlimit"
					@click="logout"
				>
					로그아웃
				</button>
				<button
					class="app-header__menu__btn-menu"
					v-else
					@click="toggleMenu"
				>
					<i class="fa fa-bars app-header__menu__btn-menu__icon"></i>
				</button>
			</div>
		</div>
		<p class="app-header__title" v-if="hasHeaderTitle">{{ headerTitle }}</p>
	</header>
</template>

<script>
	import moment from 'moment';
	import { mapState } from 'vuex';
	import NavBox from '@/components/NavBox.vue';

	export default {
		name: 'AppHeader',
		components: { NavBox },
		data() {
			return {
				isWidthOverlimit: true,
				menuIsOpen: false,
				widthLimit: 1150,
				nav1Open: false,
				time: '',
				ticking: null,
			};
		},
		computed: {
			...mapState({
				hasHeaderTitle: 'hasHeaderTitle',
				headerTitle: 'headerTitle',
				adminDomain: state => state.env.adminDomain,
				imgUrl: state => state.env.imgUrl,
			}),
			...mapState('login', {
				idRegister: 'idRegister',
				nickname: 'name',
				iat: 'iat',
				exp: 'exp',
			}),
		},
		mounted() {
			this.checkWidthOverlimit(null, window.innerWidth);
			window.addEventListener('resize', this.checkWidthOverlimit);
			window.onclick = this.clickControl;
		},
		methods: {
			timeTick() {
				clearInterval(this.ticking);
				this.ticking = setInterval(() => {
					const inTime = this.iat / 1000;
					const now = Math.floor(new Date().getTime() / 1000);
					this.time = `${Math.floor(Math.floor((now - inTime) / 60) / 60)} : ${Math.floor((now - inTime) / 60) % 60}`;
				}, 1000);
			},
			getTimeStr(mS) {
				return mS
					? moment(new Date(mS)).format('YYYY-MM-DD HH:mm')
					: '';
			},
			toggleNav1(idx) {
				this.nav1Open =
					isNaN(parseInt(idx)) || this.nav1Open !== idx ? idx : false;
			},
			clickControl(e) {
				const target = e.target;
				if (
					target.className &&
					typeof target.className === 'string' &&
					(target.className.indexOf('nav-box__nav2__btn') > -1 ||
						target.className.indexOf('nav-box__nav3__btn') > -1) &&
					target.tagName.toLowerCase() === 'a'
				) {
					this.toggleMenu(false);
				}
			},
			toggleMenu(bool) {
				const result =
					typeof bool === 'boolean' ? bool : !this.menuIsOpen;
				if (!result) this.toggleNav1(false);
				this.menuIsOpen = result;
			},
			checkWidthOverlimit(e, width) {
				const innerWidth = e ? e.target.innerWidth : width;
				if (Number(innerWidth) >= this.widthLimit) {
					this.isWidthOverlimit = true;
				} else if (Number(innerWidth) < this.widthLimit) {
					this.isWidthOverlimit = false;
				}
			},
			logout() {
				this.$store.dispatch('login/logout');
			},
		},
		watch: {
			idRegister(id) {
				if (id) {
					this.timeTick();
				}
			},
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.checkWidthOverlimit);
		},
	};
</script>

<style lang="scss" scoped>
	.app-header {
		position: relative;
		z-index: 100;

		&:after {
			content: '';
			display: block;
			clear: both;
		}

		.app-header__login-info {
			height: 32px;
			background: #f4f7fa;
			padding: 0 40px;
			text-align: right;

			&:after {
				content: '';
				display: block;
				clear: both;
			}

			[env='dev'] & {
				border-top: 3px solid red;
				background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="120px" height="25px"><text fill="pink" x="20" y="18" transform="rotate(10)" font-size="20">TEST</text></svg>');
				overflow: hidden;
			}
		}

		.app-header__login-info__time {
			float: left;
			line-height: 16px;
		}

		.app-header__login-info__nickname {
			float: right;
			line-height: 32px;
			font-size: 1.125rem;

			@media (max-width: 500px) {
				display: none;
			}
		}

		.app-header__login-info__ticking {
			float: right;
			margin-left: 20px;
			line-height: 32px;
			color: #657088;
			font-size: 1.125rem;

			@media (max-width: 768px) {
				display: none;
			}
		}

		.app-header__menu {
			position: relative;
			height: 56px;
			background-color: #495470;

			&:after {
				content: '';
				display: block;
				clear: both;
			}
		}

		.app-header__menu__side-left {
			float: left;
			height: 100%;
			padding-left: 243px;
		}

		.app-header__menu__logo {
			position: absolute;
			display: block;
			width: 163px;
			height: 15px;
			bottom: 21px;
			left: 40px;
		}

		.app-header__menu__side-right {
			float: right;
			height: 100%;
		}

		.app-header__menu__btn-logout {
			margin: 13px 40px 0 0;
			background-color: #495470;
			border: solid 1px #7a839b;
			vertical-align: top;
			color: #b9c1d7;

			&:hover {
				border-color: #d3ddf7;
				color: #d3ddf7;
			}

			&:active {
				background-color: rgba(211, 221, 247, 0.1);
				border-color: #7a839b;
				color: #b9c1d7;
			}
		}

		.app-header__menu__btn-menu {
			cursor: pointer;
			padding: 13px;
			margin-right: 27px;
		}

		.app-header__menu__btn-menu__icon {
			color: #e3eaf6;
			font-size: 30px;
			pointer-events: none;
		}

		.app-header__title {
			float: left;
			width: 100%;
			height: 56px;
			background: #dfe6ee;
			line-height: 56px;
			text-align: center;
			color: #303643;
			font-size: 1.375rem;
			font-weight: 700;
		}
	}
</style>
